export default {
  name: 'MainLogoutTransition',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/main/components/LogoutTransition/index.js